var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:[
    !!_vm.size && ("text-" + _vm.size),
    !!_vm.color && !_vm.disabled && ("text-" + _vm.color),
    { 'text-basic-600': _vm.disabled },
    _vm.disabled ? 'cursor-not-allowed' : 'cursor-pointer'
  ],attrs:{"title":_vm.title},on:{"click":function($event){!_vm.disabled && _vm.$emit('click', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }